<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Все бизнесы «{{ entity.title }}»</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="overflow-hidden border border-gray-300 rounded-md">
                        <div class="flex items-center bg-gray-100">
                            <div class="w-2/5 py-2 font-bold pl-2">Настройки</div>
                            <div class="w-3/5 py-2 font-bold pl-2">Описание</div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/common`)">
                                    Общее
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Название, картинки, иконки, цвета...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/dialogs`)">
                                    Окна статусов 
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Всплывающие окна при смене определенных статусов в выполняемом заказе...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/statuses`)">
                                    Статусы в приложении
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Настройки видимости и отображения статусов заказа в приложении...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/pushes`)">
                                    Клиентские пуши
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Настройки пушей при смене статуса заказа...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/telegram`)">
                                    Телеграм партнеров
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Телеграм бот партнеров, уведомления и настройки...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/images`)">
                                    Изображения
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Изображения по умолчанию...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/delivery`)">
                                    Доставка
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Цены доставки в зависимости от параметров...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/waiting-price`)">
                                    Платное ожидание
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Настройки платного ожидания...
                                </span>
                            </div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push(`/settings/entities/${$route.params.id}/delivery-settings`)">
                                    Страница доставки
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                <span class="">
                                    Включение/выключение календаря...
                                </span>
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        name: 'EntitiesTypeSettings',

        data: () => ({
            entity: {},
        }),

        mounted() {
            const id = this.$route.params.id;
            this.axios.get('/entities-type/' + id)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
    }
</script>
<style scoped lang="scss">
    .disabled {
        color: #8a93a2;
        &:hover {
            text-decoration: none;
            cursor: inherit;
        }
    }
</style>
